<template>
<div class="chapter">
<div class="inner_page">
<p class="h1">CONTENTS</p>
<p class="toc"><a href="#/acknowledgements">Acknowledgements</a></p>
<p class="toc"><a href="#/introduction">Introduction</a></p>
<p class="toc1"><a href="#/chapter01">1. Questions Linger About Engineer’s Death</a></p>
<p class="toc"><span href="#/chapter02" title="Link target outside of Sample">2. No Leads to Teachers’ Slayer</span></p>
<p class="toc"><span href="#/chapter03" title="Link target outside of Sample">3. Was It Murder or Suicide?</span></p>
<p class="toc"><span href="#/chapter04" title="Link target outside of Sample">4. The Disappearance of Melvin Horst</span></p>
<p class="toc"><span href="#/chapter05" title="Link target outside of Sample">5. Deadly Deals</span></p>
<p class="toc"><span href="#/chapter06" title="Link target outside of Sample">6. Gunned Down in Cold Blood</span></p>
<p class="toc"><span href="#/chapter07" title="Link target outside of Sample">7. A Deadly Affair</span></p>
<p class="toc"><span href="#/chapter08" title="Link target outside of Sample">8. Carnival Girl</span></p>
<p class="toc"><span href="#/chapter09" title="Link target outside of Sample">9. Love Gone Wrong</span></p>
<p class="toc"><span href="#/chapter10" title="Link target outside of Sample">10. Whatever Happened to Anita?</span></p>
<p class="toc1"><span href="#/sources" title="Link target outside of Sample">Sources</span></p>
<p class="toc"><span href="#/author" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?20d7ac40